// ─── Shared Bilingual Services Data ────────────────────────────────────────
// Used by both Services.jsx and Appointment.jsx

export const SERVICE_CATEGORIES = [
  {
    id: 'rituals',
    en: { label: 'Ritual & Puja Services', icon: '🪔' },
    np: { label: 'पूजा तथा संस्कार सेवाहरू', icon: '🪔' },
    color: '#c0392b',
    bg: '#fff5f5',
    border: '#f5c6c6',
    services: [
      {
        id: 'wedding',
        en: {
          title: 'Hindu Weddings',
          subtitle: 'Vivaha Sanskar',
          desc: 'Complete Vedic wedding ceremony performed with full rituals, mantras, and sacred fire (Agni). A lifelong bond blessed by the divine.',
        },
        np: {
          title: 'हिन्दू विवाह',
          subtitle: 'विवाह संस्कार',
          desc: 'पूर्ण वैदिक विधि, मन्त्र र पवित्र अग्निसहित सम्पन्न हुने विवाह संस्कार। ईश्वरको आशीर्वादले जोडिने आजीवन बन्धन।',
        },
      },
      {
        id: 'griha',
        en: {
          title: 'Griha Pravesh',
          subtitle: 'House Blessing Ceremony',
          desc: 'Sacred housewarming puja to purify the new home, invite positive energy, and receive blessings for prosperity and happiness.',
        },
        np: {
          title: 'गृह प्रवेश',
          subtitle: 'घर आशीर्वाद समारोह',
          desc: 'नयाँ घरलाई शुद्ध पार्न, सकारात्मक ऊर्जा आमन्त्रण गर्न र समृद्धि तथा सुखका लागि आशीर्वाद लिन गरिने पवित्र पूजा।',
        },
      },
      {
        id: 'satyanarayan',
        en: {
          title: 'Satyanarayan Puja',
          subtitle: 'Sacred Vow Ceremony',
          desc: 'A deeply revered puja to Lord Vishnu performed on auspicious occasions for blessings, fulfilment of wishes, and family wellbeing.',
        },
        np: {
          title: 'सत्यनारायण पूजा',
          subtitle: 'पवित्र व्रत समारोह',
          desc: 'शुभ अवसरमा भगवान विष्णुलाई समर्पित यो पूजाले इच्छापूर्ति र परिवारको कल्याण गर्दछ।',
        },
      },
      {
        id: 'navagraha',
        en: {
          title: 'Navagraha Puja',
          subtitle: 'Nine Planets Ceremony',
          desc: 'Appease the nine planetary deities to remove doshas, reduce negative influences, and align cosmic energies for your benefit.',
        },
        np: {
          title: 'नवग्रह पूजा',
          subtitle: 'नौ ग्रह समारोह',
          desc: 'नौ ग्रह देवताहरूलाई प्रसन्न पार्दै दोष हटाउन र ब्रह्माण्डीय ऊर्जालाई आफ्नो पक्षमा लगाउन।',
        },
      },
      {
        id: 'rudra',
        en: {
          title: 'Rudrabhishek Puja',
          subtitle: 'Sacred Shiva Abhishek',
          desc: 'Ritualistic bathing of Lord Shiva\'s Lingam with sacred materials, chanting of Rudram, for health, peace, and liberation.',
        },
        np: {
          title: 'रुद्राभिषेक पूजा',
          subtitle: 'पवित्र शिव अभिषेक',
          desc: 'रुद्रम् मन्त्रको जापसहित भगवान शिवको लिंगमा पवित्र द्रव्यले अभिषेक गरी स्वास्थ्य, शान्ति र मोक्षका लागि।',
        },
      },
      {
        id: 'bratabandha',
        en: {
          title: 'Bratabandha',
          subtitle: 'Sacred Thread Ceremony',
          desc: 'The sacred Upanayana ceremony marking a boy\'s initiation into Vedic studies and spiritual life with the holy thread (Janai).',
        },
        np: {
          title: 'ब्रतबन्ध',
          subtitle: 'यज्ञोपवीत संस्कार',
          desc: 'बालकलाई वैदिक अध्ययन र आध्यात्मिक जीवनमा दीक्षित गर्ने पवित्र उपनयन संस्कार (जनै धारण)।',
        },
      },
      {
        id: 'namkaran',
        en: {
          title: 'Naming Ceremony',
          subtitle: 'Namkaran Sanskar',
          desc: 'A joyful Vedic ceremony to formally give a newborn their sacred name, invoking divine blessings for a long and healthy life.',
        },
        np: {
          title: 'नामकरण संस्कार',
          subtitle: 'नवजात शिशुको नामकरण',
          desc: 'नवजात शिशुलाई पवित्र नाम दिने खुसियाली वैदिक समारोह, दीर्घ र स्वस्थ जीवनका लागि ईश्वरीय आशीर्वाद।',
        },
      },
      {
        id: 'godhbharai',
        en: {
          title: 'Baby Shower Ceremony',
          subtitle: 'Godh Bharai',
          desc: 'A traditional blessing ceremony for the expectant mother and unborn child, filled with prayers, gifts, and joyful rituals.',
        },
        np: {
          title: 'गोद भराई',
          subtitle: 'शिशु स्वागत समारोह',
          desc: 'गर्भवती आमा र अजन्मे बच्चाका लागि प्रार्थना, उपहार र आनन्दपूर्ण रीतिरिवाजले भरिएको परम्परागत आशीर्वाद समारोह।',
        },
      },
      {
        id: 'annaprashan',
        en: {
          title: 'Annaprashan',
          subtitle: 'First Rice Feeding Ceremony',
          desc: 'The sacred ceremony marking a baby\'s first intake of solid food — a joyous milestone blessed with Vedic prayers.',
        },
        np: {
          title: 'अन्नप्राशन संस्कार',
          subtitle: 'पहिलो अन्न भोजन समारोह',
          desc: 'शिशुले पहिलो पटक अन्न ग्रहण गर्ने शुभ संस्कार — वैदिक मन्त्रले आशीर्वाद दिइने आनन्दको क्षण।',
        },
      },
      {
        id: 'birthday',
        en: {
          title: 'Birthday & Special Occasion Pujas',
          subtitle: 'Ayushya Homam & More',
          desc: 'Customised pujas and homams for birthdays, anniversaries, and other special occasions to seek divine blessings.',
        },
        np: {
          title: 'जन्मदिन र विशेष अवसर पूजाहरू',
          subtitle: 'आयुष्य होम र अन्य',
          desc: 'जन्मदिन, वर्षगाँठ र अन्य विशेष अवसरका लागि अनुकूलित पूजा र होमहरू।',
        },
      },
      {
        id: 'lakshmi',
        en: {
          title: 'Lakshmi Puja & Diwali Puja',
          subtitle: 'Festival of Lights Ceremony',
          desc: 'Invoke the goddess of wealth and prosperity with this special puja performed on Diwali and other auspicious occasions.',
        },
        np: {
          title: 'लक्ष्मी पूजा र दीपावली पूजा',
          subtitle: 'दियोको पर्व समारोह',
          desc: 'दीपावली र अन्य शुभ अवसरमा धन र समृद्धिकी देवी लक्ष्मीको पूजाआजा।',
        },
      },
      {
        id: 'ganesh',
        en: {
          title: 'Ganesh Puja',
          subtitle: 'Remover of Obstacles',
          desc: 'Worship of Lord Ganesh before starting any new endeavour to remove obstacles and ensure success and good fortune.',
        },
        np: {
          title: 'गणेश पूजा',
          subtitle: 'विघ्नहर्ता पूजा',
          desc: 'कुनै पनि नयाँ कार्य आरम्भ गर्नुअघि विघ्नहर्ता गणेशको पूजाआजा गरी सफलता र सौभाग्य प्राप्त गर्नु।',
        },
      },
      {
        id: 'shraddha',
        en: {
          title: 'Shraddha & Funeral Rites',
          subtitle: 'Antim Sanskar & Pitru Tarpan',
          desc: 'Compassionate and dignified Vedic funeral rites and annual Shraddha ceremonies to honour and liberate the departed souls.',
        },
        np: {
          title: 'श्राद्ध र अन्तिम संस्कार',
          subtitle: 'अन्तिम संस्कार र पितृ तर्पण',
          desc: 'दिवंगत आत्माहरूको सम्मान र मुक्तिका लागि करुणापूर्ण वैदिक अन्तिम संस्कार र वार्षिक श्राद्ध।',
        },
      },
      {
        id: 'vastu',
        en: {
          title: 'Vastu Puja',
          subtitle: 'Sacred Space Purification',
          desc: 'Harmonise your living or work space with Vastu principles and sacred puja to attract positivity and remove negative energies.',
        },
        np: {
          title: 'वास्तु पूजा',
          subtitle: 'पवित्र स्थान शुद्धीकरण',
          desc: 'वास्तु सिद्धान्त र पवित्र पूजाद्वारा आफ्नो घर वा कार्यस्थललाई सकारात्मकताले भर्नु र नकारात्मक ऊर्जा हटाउनु।',
        },
      },
      {
        id: 'hawan',
        en: {
          title: 'Hawan / Yagya Ceremonies',
          subtitle: 'Sacred Fire Rituals',
          desc: 'Sacred fire rituals with offerings of ghee, herbs, and grains into the Agni, chanting Vedic mantras for health, peace, and cosmic balance.',
        },
        np: {
          title: 'हवन / यज्ञ समारोह',
          subtitle: 'पवित्र अग्नि अनुष्ठान',
          desc: 'घिउ, जडीबुटी र अन्नको आहुतिसहित वैदिक मन्त्र जापद्वारा स्वास्थ्य, शान्ति र ब्रह्माण्डीय सन्तुलनका लागि अग्नि अनुष्ठान।',
        },
      },
    ],
  },

  {
    id: 'astrology',
    en: { label: 'Astrology Services', icon: '🔭' },
    np: { label: 'ज्योतिष सेवाहरू', icon: '🔭' },
    color: '#1b126c',
    bg: '#f0effc',
    border: '#c5c2f0',
    services: [
      {
        id: 'spiritual-consult',
        en: {
          title: 'Religious & Spiritual Consultations',
          subtitle: 'Dharmic Guidance',
          desc: 'Personal one-on-one sessions for spiritual guidance, dharmic advice, and answering deep questions about Hindu philosophy and practices.',
        },
        np: {
          title: 'धार्मिक तथा आध्यात्मिक परामर्श',
          subtitle: 'धार्मिक मार्गदर्शन',
          desc: 'हिन्दू दर्शन र अभ्यासका बारेमा व्यक्तिगत आध्यात्मिक मार्गदर्शन र धार्मिक सल्लाहका लागि व्यक्तिगत सत्र।',
        },
      },
      {
        id: 'jyotish',
        en: {
          title: 'Vedic Astrology Consultations',
          subtitle: 'Jyotish Shastra',
          desc: 'In-depth Vedic astrology reading using your birth chart (Janma Kundali) to reveal life patterns, strengths, challenges, and remedies.',
        },
        np: {
          title: 'वैदिक ज्योतिष परामर्श',
          subtitle: 'ज्योतिष शास्त्र',
          desc: 'जन्म कुण्डलीको प्रयोग गरी जीवनका ढाँचा, शक्ति, चुनौती र उपायहरू प्रकट गर्ने गहन वैदिक ज्योतिष वाचन।',
        },
      },
      {
        id: 'kundali',
        en: {
          title: 'Horoscope Reading & Analysis',
          subtitle: 'Kundali Vichar',
          desc: 'Detailed analysis of your Janma Kundali covering all 12 houses, planetary positions, dashas, and yogas shaping your destiny.',
        },
        np: {
          title: 'कुण्डली पठन र विश्लेषण',
          subtitle: 'कुण्डली विचार',
          desc: '१२ भाव, ग्रह स्थिति, दशा र योगहरू समेट्ने जन्म कुण्डलीको विस्तृत विश्लेषण।',
        },
      },
      {
        id: 'matching',
        en: {
          title: 'Marriage Compatibility',
          subtitle: 'Kundali Matching / Gun Milan',
          desc: 'Comprehensive Gun Milan and Kundali Matching to assess compatibility between prospective partners for a harmonious married life.',
        },
        np: {
          title: 'विवाह कुण्डली मिलान',
          subtitle: 'गुण मिलान',
          desc: 'सुमधुर वैवाहिक जीवनका लागि भावी जोडीबीचको अनुकूलता मूल्याङ्कन गर्ने व्यापक गुण मिलान र कुण्डली मिलान।',
        },
      },
      {
        id: 'career',
        en: {
          title: 'Career & Education Guidance',
          subtitle: 'Through Astrology',
          desc: 'Use the power of Vedic astrology to identify the most favourable career paths, education choices, and timing for major decisions.',
        },
        np: {
          title: 'करियर र शिक्षा मार्गदर्शन',
          subtitle: 'ज्योतिषद्वारा',
          desc: 'वैदिक ज्योतिषको शक्ति प्रयोग गरी सबैभन्दा अनुकूल करियर मार्ग, शिक्षाका विकल्प र महत्त्वपूर्ण निर्णयका लागि उचित समय पहिचान गर्नु।',
        },
      },
      {
        id: 'graha-dosh',
        en: {
          title: 'Graha Dosh Analysis & Remedies',
          subtitle: 'Mangal Dosh, Kaal Sarp & More',
          desc: 'Identification of planetary afflictions (Doshas) in your chart with practical Vedic remedies — gemstones, mantras, and rituals.',
        },
        np: {
          title: 'ग्रह दोष विश्लेषण र उपाय',
          subtitle: 'मंगल दोष, काल सर्प र अन्य',
          desc: 'कुण्डलीमा ग्रह दोषहरू पहिचान गरी व्यावहारिक वैदिक उपायहरू — रत्न, मन्त्र र अनुष्ठानहरू।',
        },
      },
    ],
  },

  {
    id: 'teaching',
    en: { label: 'Teaching & Education', icon: '📖' },
    np: { label: 'शिक्षण तथा शिक्षा', icon: '📖' },
    color: '#0a7a4e',
    bg: '#f0fdf8',
    border: '#bbf0d9',
    services: [
      {
        id: 'nepali-teaching',
        en: {
          title: 'Nepali Language Teaching',
          subtitle: 'For All Levels',
          desc: 'Learn to speak, read, and write Nepali fluently. Classes tailored for beginners to advanced learners — children and adults welcome.',
        },
        np: {
          title: 'नेपाली भाषा शिक्षण',
          subtitle: 'सबै तहका लागि',
          desc: 'नेपाली धाराप्रवाह बोल्न, पढ्न र लेख्न सिक्नुहोस्। शुरुआतदेखि उन्नत स्तरसम्मका लागि अनुकूलित कक्षाहरू — बालबालिका र वयस्क दुवैलाई स्वागत।',
        },
      },
      {
        id: 'sanskrit-teaching',
        en: {
          title: 'Sanskrit Language Teaching',
          subtitle: 'The Language of the Vedas',
          desc: 'Learn the sacred language of the Vedas and scriptures. Covers Sanskrit alphabet, grammar, pronunciation, shlokas, and Vedic chanting.',
        },
        np: {
          title: 'संस्कृत भाषा शिक्षण',
          subtitle: 'वेदको भाषा',
          desc: 'वेद र शास्त्रहरूको पवित्र भाषा सिक्नुहोस्। संस्कृत वर्णमाला, व्याकरण, उच्चारण, श्लोक र वैदिक मन्त्रोच्चारण समावेश।',
        },
      },
      {
        id: 'cultural-teaching',
        en: {
          title: 'Cultural & Religious Education',
          subtitle: 'Hindu Dharma & Traditions',
          desc: 'Deepen your understanding of Hindu culture, festivals, traditions, and philosophy — ideal for diaspora communities and seekers.',
        },
        np: {
          title: 'सांस्कृतिक र धार्मिक शिक्षा',
          subtitle: 'हिन्दू धर्म र परम्परा',
          desc: 'हिन्दू संस्कृति, पर्व, परम्परा र दर्शनको गहन ज्ञान — प्रवासी समुदाय र जिज्ञासुहरूका लागि उपयुक्त।',
        },
      },
    ],
  },
];

// Flat list of all services (for appointment dropdown)
export const ALL_SERVICES_FLAT = SERVICE_CATEGORIES.flatMap((cat) =>
  cat.services.map((svc) => ({
    ...svc,
    categoryId: cat.id,
    categoryEn: cat.en.label,
    categoryNp: cat.np.label,
    categoryIcon: cat.en.icon,
    color: cat.color,
  }))
);
